const initial = {
  id: '',
  display: true,
};

export default (state = initial, event) => {
  switch (event.type) {
    case 'PEOPLE_PAGE':
      return {
        ...state,
        id: event.data.id,
        display: event.data.display,
        checked: event.data.checked,
      };
    default:
      return state;
  }
};
